import { ObjectToCamel, objectToCamel } from 'ts-case-convert';

import { MAP_DEFAULTS } from '@app/consts/consts';
import { LocationType, LocationTypeEnum } from '@app/enums/location-type.enum';
import { GeoBaseSCModel, GeoCityModel } from '@app/models/geo.model';
import { EsServiceBase } from '@app/services/abstracts/es-service.base';

const GEO_INDEX_MAP = {
    [LocationTypeEnum.City]: 'noc-geo-cities',
    [LocationTypeEnum.Country]: 'noc-geo-countries',
    [LocationTypeEnum.Region]: 'noc-geo-regions',
    [LocationTypeEnum.Voivodeship]: 'noc-geo-voivodeships',
};

export class EsGeoService extends EsServiceBase {
    private static _instance: EsGeoService;

    public static get instance(): EsGeoService {
        if (!this._instance) {
            this._instance = new EsGeoService();
        }

        return this._instance;
    }

    public async getGeoDetails<T extends GeoBaseSCModel>(
        geoId: string,
        locationType: LocationType,
    ): Promise<ObjectToCamel<T> | null> {
        const indexName =
            GEO_INDEX_MAP[locationType as keyof typeof GEO_INDEX_MAP] ??
            GEO_INDEX_MAP[LocationTypeEnum.Country];

        const finalGeoId = locationType in GEO_INDEX_MAP ? geoId : MAP_DEFAULTS.GEO_ID;

        try {
            const response = await this.get<T>(indexName, finalGeoId);
            return objectToCamel(response._source);
        } catch (error) {
            return null;
        }
    }

    public async getCityDetails<GeoCitySCModel>(cityId: string): Promise<GeoCityModel | null> {
        const indexName = GEO_INDEX_MAP[LocationTypeEnum.City];

        try {
            const response = await this.getMany<GeoCitySCModel>(indexName, {
                query: {
                    match: {
                        nop_city_id: cityId,
                    },
                },
            });

            return objectToCamel(response.hits[0]._source) as unknown as GeoCityModel;
        } catch (error) {
            return null;
        }
    }
}
